var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.45093 15.7523C12.9167 15.7523 15.7523 12.9167 15.7523 9.45093C15.7523 5.98518 12.9167 3.14956 9.45093 3.14956C5.98518 3.14956 3.14956 5.98518 3.14956 9.45093C3.14956 12.9167 5.98518 15.7523 9.45093 15.7523ZM9.45093 1.57422C13.7831 1.57422 17.3276 5.11874 17.3276 9.45093C17.3276 13.7831 13.7831 17.3276 9.45093 17.3276C5.11874 17.3276 1.57422 13.7831 1.57422 9.45093C1.57422 5.11874 5.11874 1.57422 9.45093 1.57422ZM13.3893 10.9475L12.8379 11.9715L8.66326 9.68723V5.51257H9.84477V8.97833L13.3893 10.9475Z",
    fill: "#3C3C3C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.7c9a3943069c4a3b667179b6bdf406e8.svg";
export { ForwardRef as ReactComponent };